export default __webpack_public_path__ + "static/media/Wallet.d1b2c875.svg";